export const resizeImageIfNeeded = (
  file: File,
  maxSizeKB: number = 45
): Promise<File> => {
  return new Promise((resolve) => {
    const fileSizeKB = file.size / 1024;

    if (fileSizeKB <= maxSizeKB) {
      resolve(file);
      return;
    }

    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d")!;

    img.onload = () => {
      let { width, height } = img;
      const maxDimension = 400;

      if (width > height && width > maxDimension) {
        height = (height * maxDimension) / width;
        width = maxDimension;
      } else if (height > maxDimension) {
        width = (width * maxDimension) / height;
        height = maxDimension;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      const compress = (quality: number) => {
        canvas.toBlob(
          (blob) => {
            if (blob && (blob.size / 1024 <= maxSizeKB || quality <= 0.3)) {
              const resizedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            } else {
              compress(quality - 0.1);
            }
          },
          "image/jpeg",
          quality
        );
      };

      compress(0.9);
    };

    img.src = URL.createObjectURL(file);
  });
};
